import View from './View';

export { default as View, getDropdownMenuStyles } from './View';

export default View;
